














import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import Header from '@/components/Header.vue';
import { SurveySingleSelectOptions } from '@/models/survey-elements/single-select-options';
import { EventBus } from '@/event-bus';
import { SurveySingleSelectElement } from '@/models/survey-elements/single-select-element';
import { WIDGET_EVENTS } from '@/const/widget-events';
import { SingleSelectActions } from '@/models/survey-elements/single-select-options';
import GoogleMapsMixin from '@/mixins/googleMapsMixin';

@Component({
  name: 'single-button-select-widget',
  components: {
    Header,
    ButtonElement: () => import('@/components/widgets/ButtonElement.vue'),
  },
})
export default class SingleButtonSelectWidget extends Mixins(GoogleMapsMixin) {
  @Prop({ type: Array, required: true }) options!: SurveySingleSelectOptions[];
  @Prop({ type: String }) title?: string;
  @Prop({ type: Object }) field?: SurveySingleSelectElement;

  private isGoogleMapsAction = false;

  private get isAnswering() {
    return this.$store.state.isAnswerInProgress;
  }

  async onButtonClickHandler(
    value: Partial<SurveySingleSelectOptions>,
    action: SingleSelectActions | null
  ) {
    this.isGoogleMapsAction = action === SingleSelectActions.GO_TO_GOOGLE_MAPS;
    EventBus.$emit(WIDGET_EVENTS.SUBMIT, { field: this.field, value });
  }

  @Watch('isAnswering')
  async onAnswerSent(current: boolean, previous: boolean) {
    if (!this.isGoogleMapsAction) return;
    if (!current && previous) {
      await this.goToMaps();
    }
  }
}
